import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 10,
        marginTop: 5,
        fontFamily: 'Helvetica-Bold',
        textIndent:'5px'
    },
    container:{
        paddingTop:'3px',
        paddingLeft:'3px',
        paddingRight:'3px',
        height:'20px',
        fontSize:10,
        flexDirection: 'row',
        fontWeight:'normal',
        border: '1px solid #000000',
        borderRadius:'3px'
    },
    text:{
        fontSize: 10,
        whiteSpace: 'pre-line',
        lineHeight:'15px'
    }
});

const ProposalFreight = ({invoice}) => (  
   <View style={{flexDirection: 'row'}}>
        <View style={{width:'49%', 'marginRight':'1%'}}>
            <Text style={styles.reportTitle}>Prazo de entrega</Text>
            <View style={styles.container}>
                <Text>{invoice?.condicaoComercial?.deadline?.name}</Text>
            </View>
        </View>
        <View style={{width:'49%', 'marginLeft':'1%'}}>
            <Text style={styles.reportTitle}>Frete</Text>
            <View style={styles.container}>
                <Text>{invoice?.condicaoComercial?.freightType?.name}</Text>
            </View>
        </View>
   </View>
);
  
export default ProposalFreight